export default __webpack_public_path__ + "static/media/group4721050-5xzp.7c579127.svg";